/** @jsxRuntime classic */
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';

import { Animation } from './Animation';

import { useAnimationsSectionContext } from './Context';
import { AnimationSection } from './types';

type Props = { sections: AnimationSection[] };

const Styles = labelStyles('AnimationsSection', {
  root: (subNavHeight: number) =>
    css({
      zIndex: 1,
      top: '0px',
      height: '100vh',
      marginTop: `${-subNavHeight}px`,
      width: '45%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'sticky',
    }),
});

export function StickySections({ sections }: Props) {
  const {
    isAnimationScrollable,
    subNavHeight,
    animationRefs,
    sectionIndex,
  } = useAnimationsSectionContext();

  return !isAnimationScrollable ? (
    <div css={Styles.root(subNavHeight)}>
      {sections.map(
        (
          {
            animationAssetsUrl,
            animationDataUrl,
            animationSpeed,
            mediaAltText,
          },
          index,
        ) => (
          <Animation
            animationAssetsUrl={animationAssetsUrl}
            animationDataUrl={animationDataUrl}
            animationSpeed={animationSpeed}
            ariaLabel={mediaAltText}
            autoPlay={index === 0}
            isVisible={sectionIndex === index}
            key={`${animationDataUrl}-${index}`}
            ref={(ref) => {
              if (ref) animationRefs.current[index] = ref;
            }}
          />
        ),
      )}
    </div>
  ) : null;
}
